import clsx from "clsx";
import Styles from "./Table.module.scss";
import { Table } from "react-bootstrap";
import { BsBox2Fill } from "react-icons/bs";
import { useCallback, useMemo } from "react";
import { FaRegTrashAlt } from "react-icons/fa";

export default function TableComponent({
  data,
  header,
  onRowClick,
  customFormatters = {},
  isShowDelete = false,
  handleDelete,
}) {
  const formatCell = useCallback(
    (item, key) => {
      const formatter = customFormatters[key.name];

      if (formatter) {
        switch (formatter.length) {
          case 1:
            return formatter(item[key.name]);
          case 2:
            return formatter(item, key);
          default:
            return item[key.name];
        }
      }
      return item[key.name];
    },
    [customFormatters]
  );

  const renderEmptyTable = useMemo(() => {
    return (
      <div className={clsx(Styles.mainWrap)}>
        <div className={clsx(Styles.emptyBox)}>
          <BsBox2Fill className={clsx(Styles.iconEmpty)} />
          <span className={clsx(Styles.titleEmpty)}>Dữ Liệu Rỗng</span>
        </div>
      </div>
    );
  }, []);

  const renderDeleteBtn = useCallback(
    (id) => {
      return (
        <td className={clsx(Styles.itemBody)}>
          <FaRegTrashAlt onClick={() => handleDelete(id)} />
        </td>
      );
    },
    [handleDelete]
  );

  const renderTable = useMemo(() => {
    return (
      <Table
        className={clsx(Styles.mainWrap)}
        striped
        bordered
        hover
        variant="light"
      >
        <thead className={clsx(Styles.responsive_table)}>
          <tr className={clsx(Styles.table_header)}>
            {header.map((header, index) => (
              <th className={clsx(Styles.itemHeader)} key={index}>
                {header.label}
              </th>
            ))}
            {isShowDelete ? <th></th> : <></>}
          </tr>
        </thead>
        <tbody className={clsx(Styles.body_table)}>
          {data.map((item, index) => (
            <tr
              onClick={() => onRowClick && onRowClick(item)}
              className={clsx(Styles.tr)}
              key={index}
            >
              {header.map((key, i) => (
                <td className={clsx(Styles.item_body)} key={i}>
                  {formatCell(item, key)}
                </td>
              ))}
              {isShowDelete ? renderDeleteBtn(item.id) : <></>}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }, [data, header, formatCell, isShowDelete, onRowClick, renderDeleteBtn]);

  return <>{data && data.length > 0 ? renderTable : renderEmptyTable}</>;
}
